import React,{useState,useMemo} from 'react';
import {motion} from 'framer-motion';
import {format} from 'date-fns';
import {es} from 'date-fns/locale';
import {useData} from '../../context/DataContext';
import ReportFilters from './ReportFilters';
import ReportPreview from './ReportPreview';
import PDFGenerator from './PDFGenerator';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiFileText,FiDownload}=FiIcons;

const ReportsTab=()=> {
  const {incidents}=useData();
  const [filters,setFilters]=useState({dateFrom: '',dateTo: '',status: '',priority: ''});
  const [isGeneratingPDF,setIsGeneratingPDF]=useState(false);

  const filteredIncidents=useMemo(()=> {
    return incidents.filter(incident=> {
      const incidentDate=new Date(incident.createdAt);

      // Date filters
      if (filters.dateFrom) {
        const fromDate=new Date(filters.dateFrom);
        if (incidentDate < fromDate) return false;
      }

      if (filters.dateTo) {
        const toDate=new Date(filters.dateTo);
        toDate.setHours(23,59,59,999); // End of day
        if (incidentDate > toDate) return false;
      }

      // Status filter
      if (filters.status && incident.status !==filters.status) {
        return false;
      }

      // Priority filter
      if (filters.priority && incident.priority !==filters.priority) {
        return false;
      }

      return true;
    });
  },[incidents,filters]);

  const handleGeneratePDF=async ()=> {
    setIsGeneratingPDF(true);
    try {
      await PDFGenerator.generateReport(filteredIncidents,filters);
    } catch (error) {
      console.error('Error generating PDF:',error);
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  const clearFilters=()=> {
    setFilters({dateFrom: '',dateTo: '',status: '',priority: ''});
  };

  const hasActiveFilters=Object.values(filters).some(value=> value);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-bold text-gray-800">Informes</h2>
        {/* CORREGIDO: Altura exacta de 36px (h-9) */}
        <motion.button 
          whileTap={{scale: 0.95}} 
          onClick={handleGeneratePDF} 
          disabled={isGeneratingPDF || filteredIncidents.length===0} 
          className="flex items-center justify-center space-x-2 px-4 py-1.5 h-9 bg-red-500 hover:bg-red-600 disabled:bg-gray-300 text-white rounded-full font-medium transition-colors text-sm whitespace-nowrap"
        >
          {isGeneratingPDF ? (
            <>
              <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Generando...</span>
            </>
          ) : (
            <>
              <SafeIcon icon={FiDownload} />
              <span>Generar PDF</span>
            </>
          )}
        </motion.button>
      </div>

      <ReportFilters 
        filters={filters} 
        onFiltersChange={setFilters} 
        onClearFilters={clearFilters} 
        hasActiveFilters={hasActiveFilters} 
      />
      <ReportPreview incidents={filteredIncidents} />
    </div>
  );
};

export default ReportsTab;